import Reflux from 'reflux';

const ToogleAction = Reflux.createActions(['dropdownToogle']);

export default ToogleAction;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/urlhandler/toogleHandlerActions.js
 **/